import { useContext } from 'react'
import type { AppDispatch } from '@redux/store'

import { useRealtimeSubscription } from '@domain-group/react-hooks'

import RealtimeContext from '@contexts/realtimeContext'

import type { TaskListModel } from '@domain-group/realhub-backend-api-types'

import useDispatch from '@hooks/useDispatch'

import * as taskListActions from '@redux/modules/taskList'

type RealtimePayload = {
  filters: {
    subject_type: string,
    subject_id: number,
  },
  payload: TaskListModel,
}

type HydrateTaskListItemParams = {
  dispatch: AppDispatch,
  realtimePayload: RealtimePayload,
  subjectId: number,
  subjectType: string,
}

const hydrateTaskList = (params: HydrateTaskListItemParams) => {
  const { hydrateTaskList: hydrateFn } = taskListActions
  const {
    dispatch,
    realtimePayload: {
      filters: {
        subject_type,
        subject_id,
      },
      payload,
    },
    subjectId,
    subjectType,
  } = params

  if (subjectType === subject_type && subjectId === subject_id){
    dispatch(hydrateFn(payload))
  }
}

type UseRealtimeTaskListsOptions = {
  subjectType: string,
  subjectId: number,
}

function useRealtimeTaskLists(options: UseRealtimeTaskListsOptions) {
  const { subjectType, subjectId } = options

  const dispatch = useDispatch()

  const realtimeContext = useContext(RealtimeContext)
  // @ts-expect-error TS2339
  const { clientRef } = realtimeContext

  // New Task Lists
  useRealtimeSubscription({
    apiKey: import.meta.env.REACT_APP_ABLY_PUBLIC_KEY,
    callbacks: {
      success: (realtimePayload: RealtimePayload) => hydrateTaskList({
        dispatch,
        realtimePayload,
        subjectId,
        subjectType,
      }),
    },
    channelName: 'taskLists',
    clientRef,
    eventName: `${subjectType}.${subjectId}.taskList.created`,
  }, [subjectType, subjectId])
}

export default useRealtimeTaskLists
